
import { Vue, Component } from 'vue-property-decorator';
import { resetPasswordWithTokenService, verifyPasswordTokenService } from '../../services/auth.services';
import ChangePasswordForm, { FormData } from '../../components/changePassword/ChangePasswordForm.vue';

@Component({
  components: {
    ChangePasswordForm,
  },
})
export default class PasswordReset extends Vue {
  get id(): string | undefined {
    return this.$route.query.id as string;
  }

  get key(): string | undefined {
    return this.$route.query.key as string;
  }

  private isPasswordResetForm = true;

  private message = this.$t('verifyPassword.messages.linkError') as string;

  private errorMessage = '';

  async mounted(): Promise<void> {
    if (!this.id || !this.key) {
      this.showErrorMessage();
      return;
    }

    this.$store.commit('setLoading', true);
    const response = await verifyPasswordTokenService(this.id, this.key);
    this.$store.commit('setLoading', false);

    if (response.successful) {
      this.message = '';
      this.isPasswordResetForm = true;
      return;
    }

    this.showErrorMessage();
  }

  private async submit({ pass, confirmPass }: FormData) {
    if (!this.id || !this.key) {
      this.showErrorMessage();
      return;
    }

    this.$store.commit('setLoading', true);
    const response = await resetPasswordWithTokenService(
      pass,
      confirmPass,
      this.id,
      this.key,
    );
    this.$store.commit('setLoading', false);

    if (!response.successful || !response.data) {
      this.errorMessage = response.errorMessage || '';
      return;
    }

    this.$store.dispatch(
      'signIn',
      { tokenData: response.data, redirectTo: this.$route.query.redirectTo },
    );
  }

  private showErrorMessage() {
    this.isPasswordResetForm = false;
    this.message = this.$t('verifyPassword.messages.linkError') as string;
  }
}
